import { render, staticRenderFns } from "./ReportsHome.vue?vue&type=template&id=710cd9fc&scoped=true&"
import script from "./ReportsHome.vue?vue&type=script&lang=js&"
export * from "./ReportsHome.vue?vue&type=script&lang=js&"
import style0 from "./ReportsHome.vue?vue&type=style&index=0&id=710cd9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cd9fc",
  null
  
)

export default component.exports